import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormControl } from '@angular/forms';
import { FieldType, FormlyFieldConfig, FormlyFieldProps as CoreFormlyFieldProps, FormlyModule } from '@ngx-formly/core';
import { Select } from 'primeng/select';  // új import

interface SelectProps extends CoreFormlyFieldProps {
  placeholder?: string;
  options?: Array<{ label: string; value: any }>;
  showClear?: boolean;
}

@Component({
  selector: 'formly-field-primeng-select',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormlyModule,
    Select
  ],
  template: `
    <p-select
      [id]="id"
      [formControl]="selectControl"
      [formlyAttributes]="field"
      [options]="props.options || []"
      [placeholder]="props.placeholder || ''"
      [showClear]="props.showClear || !props.required"
      optionLabel="label"
      optionValue="value"
      class="w-full"
      [class.ng-dirty]="showError"
      [class.ng-invalid]="showError"
    ></p-select>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormlyFieldSelect extends FieldType<FormlyFieldConfig<SelectProps>> {
  get selectControl() {
    return this.formControl as FormControl;
  }
}